import React from "react";
import { MessageCircle, Instagram, Facebook, Linkedin, MapPin, ExternalLink } from "lucide-react";
import { SITE } from "@/data/site";
import { Gonjong } from "@/components/Gonjong";

const Kontak = () => (
  <main data-testid="kontak-page">
    <section className="relative bg-lado-deep text-rice">
      <div className="mx-auto max-w-6xl px-4 pb-20 pt-16 sm:px-6 sm:pt-20">
        <p className="text-sm font-bold uppercase tracking-[0.22em] text-kunyit">
          Kontak
        </p>
        <h1
          data-testid="kontak-h1"
          className="mt-3 max-w-2xl font-display text-4xl font-black leading-tight sm:text-5xl"
        >
          Sampaikan, kami mendengarkan
        </h1>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-rice/85 sm:text-lg">
          Kritik, saran, kemitraan, hingga pemesanan nasi box — hubungi kami
          melalui kanal resmi berikut.
        </p>
      </div>
      <div className="absolute bottom-0 left-0 right-0 text-rice">
        <Gonjong />
      </div>
    </section>

    <section className="mx-auto max-w-6xl px-4 py-16 sm:px-6 sm:py-20">
      <div className="grid gap-6 md:grid-cols-2">
        <div className="rounded-2xl bg-ijo p-8 text-rice sm:p-10">
          <MessageCircle className="h-8 w-8" aria-hidden="true" />
          <h2 className="mt-4 font-display text-2xl font-bold">Kritik & Saran</h2>
          <p className="mt-2 text-sm leading-relaxed text-rice/85 sm:text-base">
            Masukan Anda membantu kami menjaga kualitas rasa dan pelayanan di
            setiap outlet.
          </p>
          <a
            href={SITE.wa.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="kontak-wa-main"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-rice px-6 py-3 text-base font-bold text-ijo transition-transform hover:-translate-y-0.5"
          >
            WhatsApp {SITE.wa.label}
          </a>
        </div>
        <div className="rounded-2xl border-2 border-ink/15 bg-card p-8 sm:p-10">
          <MessageCircle className="h-8 w-8 text-lado" aria-hidden="true" />
          <h2 className="mt-4 font-display text-2xl font-bold">Partnership</h2>
          <p className="mt-2 text-sm leading-relaxed text-ink/75 sm:text-base">
            Tertarik bekerja sama atau membuka peluang kemitraan bersama{" "}
            {SITE.name}?
          </p>
          <a
            href={SITE.waPartner.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="kontak-wa-partner"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-lado px-6 py-3 text-base font-bold text-rice transition-transform hover:-translate-y-0.5"
          >
            WhatsApp {SITE.waPartner.label}
          </a>
        </div>
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-2">
        <div className="rounded-2xl bg-secondary/60 p-8 sm:p-10">
          <h2 className="font-display text-2xl font-bold">Media Sosial</h2>
          <p className="mt-2 text-sm leading-relaxed text-ink/75 sm:text-base">
            Ikuti kabar, promo, dan cerita dapur kami.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              href={SITE.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="kontak-instagram"
              className="inline-flex items-center gap-2 rounded-full border border-ink/20 px-5 py-2.5 text-sm font-bold transition-colors hover:border-lado hover:text-lado"
            >
              <Instagram className="h-4 w-4" aria-hidden="true" />
              Instagram
            </a>
            <a
              href={SITE.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="kontak-facebook"
              className="inline-flex items-center gap-2 rounded-full border border-ink/20 px-5 py-2.5 text-sm font-bold transition-colors hover:border-lado hover:text-lado"
            >
              <Facebook className="h-4 w-4" aria-hidden="true" />
              Facebook
            </a>
            <a
              href={SITE.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="kontak-linkedin"
              className="inline-flex items-center gap-2 rounded-full border border-ink/20 px-5 py-2.5 text-sm font-bold transition-colors hover:border-lado hover:text-lado"
            >
              <Linkedin className="h-4 w-4" aria-hidden="true" />
              LinkedIn
            </a>
          </div>
        </div>
        <div className="rounded-2xl bg-secondary/60 p-8 sm:p-10">
          <h2 className="font-display text-2xl font-bold">Kantor</h2>
          <p className="mt-2 flex items-start gap-2 text-sm leading-relaxed text-ink/80 sm:text-base">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-lado" aria-hidden="true" />
            <span>
              {SITE.company}
              <br />
              {SITE.address}
            </span>
          </p>
          <a
            href={SITE.maps}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="kontak-maps-link"
            className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-lado underline-offset-4 hover:underline"
          >
            <ExternalLink className="h-4 w-4" aria-hidden="true" />
            Lihat peta outlet kami
          </a>
        </div>
      </div>
    </section>
  </main>
);

export default Kontak;
